export default __webpack_public_path__ + "static/media/document.bdbc9f4e.svg";